import { CustomSelect } from './CustomSelect';

export default CustomSelect;
